import React from "react";
import styled from "styled-components";

const LEVEL_LABELS = [
  "Ljudens strand (1) - Introduktion",
  "Ljudens strand (1) – Livboj 1",
  "Ljudens strand (1) – Livboj 2",
  "Ljudens strand (1) – Livboj 3",
  "Ljudens strand (1) – Livboj 4",
  "Ljudens strand (1) – Livboj 5",
  "Ljudens strand (1) – Livboj 6",
  "Ljudens strand (1) – Repetition ljudfigurerna",
  "Ljudens strand (1) – Superkrafter – Vokaler",
  "Ljudens strand (1) – Bilda ord med ljudfigurer",
  "Bokstavsön - Ljudens ordning (2)",
  "Bokstavsön - Ljudfigurerna till rätt hus (3)",
  "Bokstavsön - Bokstäverna och ljudfigurerna (4)",
  "Bokstavsön - Lånarna – CQXZ (5)",
  "Vokalöarna - Hårda vokalön (6)",
  "Vokalöarna - Mjuka vokalön (7)",
  "Vokalöarna - Repetition vokalöarna",
  "Vokalöarna - Superkrafterna – hårda ön (8)",
  "Vokalöarna - Superkrafterna – mjuka ön (9)",
  "Vokalöarna - Repetition superkrafterna",
  "Uttalets sund (10)",
  "Stavningshavet (11)",
];

const UserProgressContainer = styled.div`
  h3 {
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  h4 {
    margin-bottom: 24px;
    font-size: 22px;
  }

  p,
  span {
    line-height: 24px;
    font-size: 22px;
  }
`;

const ProgressBar = styled.div`
  height: 24px;
  width: 100%;
  background-color: ${(props) => props.bgColor};
  position: relative;

  span {
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 12px;
    animation: fade-in 0.5s ease;
  }

  span:last-child {
    left: 0;
    padding-left: 12px;
  }
`;

const ProgressBarFill = styled.div`
  height: 100%;
  background-color: var(--pmbProgressSuccess);
  width: ${(props) => props.width};
  animation: progress-bar 0.5s ease;
  transform-origin: left;
`;

const ListHeader = styled.div`
  display: grid;
  grid-template-columns: 20% 60% 20%;
  grid-column-gap: 40px;
  margin-bottom: 16px;
  p {
    &:nth-child(1) {
      text-align: right;
    }
    &:nth-child(2) {
      text-align: center;
    }
  }
`;

const ProgressList = styled.ul`
  list-style: none;
`;

const ProgressListItem = styled.li`
  background-color: var(--pmbProgressListItem);
  margin-bottom: 12px;
  height: 50px;
  display: grid;
  grid-template-columns: 20% 60% 20%;
  grid-column-gap: 40px;
  align-content: center;

  p {
    &:first-of-type {
      text-align: right;
    }
  }
`;

const NoProgress = styled.p`
  text-align: center;
  padding: 50px 0;
`;

const CharacterName = styled.p`
  text-transform: capitalize;
`;
export const UserProgress = ({ user }) => {
  const selectedUser = user[0];
  const selectedUserObjects = selectedUser.characterExposureDatas;
  const characterDatas = [];

  for (const prop in selectedUserObjects) {
    let characterData = selectedUserObjects[prop];
    characterDatas.push(characterData);
  }

  let playerHasProgress = characterDatas.length;

  return (
    <UserProgressContainer>
      <h3>{selectedUser.userName}</h3>
      <h4>{LEVEL_LABELS[selectedUser.mapProgress]}</h4>
      <ListHeader>
        <p>Ljudfigur</p>
        <p>Rätt/Fel</p>
        <p>Total</p>
      </ListHeader>
      {!playerHasProgress && (
        <NoProgress>Spelaren har ingen progress än.</NoProgress>
      )}
      <ProgressList>
        {characterDatas &&
          characterDatas.map(
            ({ character, correctAnswers, wrongAnswers, exposedAmount }, i) => (
              <ProgressListItem key={i}>
                <CharacterName>{character}</CharacterName>

                <ProgressBar
                  bgColor={
                    exposedAmount > 0
                      ? "var(--pmbProgressWrongAnswers)"
                      : "var(--pmbProgressEmpty)"
                  }
                >
                  <span>{wrongAnswers}</span>
                  <ProgressBarFill
                    width={
                      correctAnswers > 0
                        ? Math.round((correctAnswers / exposedAmount) * 100) +
                          "%"
                        : "0%"
                    }
                  ></ProgressBarFill>
                  <span>{correctAnswers}</span>
                </ProgressBar>
                <p>{exposedAmount}</p>
              </ProgressListItem>
            )
          )}
      </ProgressList>
    </UserProgressContainer>
  );
};
